import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

/** Request a best-effort converter fleet warm-up before the user starts uploading. */
export const useWarmDocumentConverter = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<void, Error>(async () => {
    const response = await fetch(
      `${APIBaseChronos}/api/storage/matter/converter-warmup?matterId=${matterId}`,
      getFetchConfig({ method: FetchMethod.POST }),
    );

    if (!response.ok) {
      throw new Error('Document converter warm-up failed');
    }
  });
};
